import { PromoCode } from "@interfaces/admin/promoCode";
import style from "./TableRow.module.scss";
import { Button } from "@ui";
import cn from "classnames";
import { useDeletePromoCodeMutation } from "@RTKQuery/admin/promoCodes/promoCodes";
import { useAppSelector } from "store/hooks";
import { EPromoCode } from "@interfaces/promoCode.enum";

export function TableRow({
    data
}: {
    data: PromoCode
}) {
    const activePaginationPage = useAppSelector(state => state.promoCodesAdminPage.activePaginationPage);

    const [deletePromoCode, { isLoading, error, reset }] = useDeletePromoCodeMutation();

    return (
        <div className={style.row}>
            <div className={style.cell}>
                {data.code}
            </div>
            <div className={style.cell}>
                {data.type}
            </div>
            <div className={style.cell}>
                {
                    data.type === EPromoCode.percentage
                        ? "+" + data.bonus + "%"
                        : "+" + data.bonus + "$"
                }
            </div>
            <div className={style.cell}>
                {data.count}/{data.quantity}
            </div>
            <div className={cn(style.cell, "justify-self-center")}>
                <Button
                    text="Видалити"
                    color="blue"
                    form="rectangle"
                    variant="outline"
                    customStyle={{
                        button: "!w-[140px] !h-[34px]"
                    }}
                    onClick={() => {
                        deletePromoCode({
                            page: activePaginationPage,
                            promo_code_id: data.id
                        })
                    }}
                    loading={isLoading}
                    errors={[
                        (error && ((extractError) => {
                            const err = extractError(error)

                            return err
                        }))
                    ]}
                    resetStatus={() => {
                        reset();
                    }}
                />
            </div>
        </div>
    )
}